import { EVENT_NAME } from '@/constants/analytics'
import { MILLIS_IN_A_DAY } from '@/utils/formatDate'
import getToday from '@/utils/getToday'

const today = getToday()

export const ACTIVITY_TIMELINES = [
  { label: 'Last 1 day', id: '1d', startDate: today },
  { label: 'Last 2 days', id: '2d', startDate: new Date(today.getTime() - MILLIS_IN_A_DAY) },
  {
    label: 'Last 3 days',
    id: '3d',
    startDate: new Date(today.getTime() - MILLIS_IN_A_DAY * 3)
  },
  {
    label: 'Last 4 days',
    id: '4d',
    startDate: new Date(today.getTime() - MILLIS_IN_A_DAY * 4)
  },
  {
    label: 'Last 5 days',
    id: '5d',
    startDate: new Date(today.getTime() - MILLIS_IN_A_DAY * 5)
  },
  {
    label: 'Last 6 days',
    id: '6d',
    startDate: new Date(today.getTime() - MILLIS_IN_A_DAY * 6)
  },
  {
    label: 'Last 7 days',
    id: '7d',
    startDate: new Date(today.getTime() - MILLIS_IN_A_DAY * 7)
  },
  {
    label: 'Last 14 days',
    id: '14d',
    startDate: new Date(today.getTime() - MILLIS_IN_A_DAY * 14)
  }
]

export const TEAM_ORG_ACTIVITY_DEFAULT_TIMELINE = '14d'
export const COMMENT_FEED = 'comment'
export const FEED_WITH_LOGS = 'withLogs'
export const FEED_FILTER_PREFERENCES = [
  { name: 'Show comments only', id: COMMENT_FEED },
  { name: 'Show all activity', id: FEED_WITH_LOGS }
]
export const DEFAULT_FEED_FILTER = FEED_FILTER_PREFERENCES[1]

export const ACTIVITY_TYPE_ANALYTICS_NAME = {
  initiative_comment: EVENT_NAME.INITIATIVE_COMMENT,
  checkin: EVENT_NAME.CHECKIN,
  all: EVENT_NAME.ALL
}
export const EVENT_TYPE_FILTER_ID = {
  all: 'all',
  checkin: 'checkin',
  initiativeComment: 'initiative_comment'
}
export const EVENT_TYPE_FILTER_OPTIONS = [
  {
    id: EVENT_TYPE_FILTER_ID.all,
    label: 'All',
    filterName: '',
    filterValue: ''
  },
  {
    id: EVENT_TYPE_FILTER_ID.checkin,
    label: 'Check-in',
    filterName: 'goal_event_type',
    filterValue: 'checkin'
  },
  {
    id: EVENT_TYPE_FILTER_ID.initiativeComment,
    label: 'Comments',
    filterName: 'initiative_event_type',
    filterValue: 'comment'
  }
]

export const activityFilterDefaultState = {
  teamIds: [{ label: 'All', id: -1 }],
  from: ACTIVITY_TIMELINES.find(t => t.id === '7d'),
  activity: EVENT_TYPE_FILTER_OPTIONS[0]
}
